import {Component, OnInit} from '@angular/core';
import {SystemMaintanceModel} from './+app-custom/models/systemMaintance.model';
import {AppThemeService} from './+app-custom/theme/app-theme.service';

@Component({
    selector: 'app-root',
    template: `
        <div class="alert alert-danger system-maintance-alert" *ngIf="isMaintanced">
            {{systemMaintance.description}}
        </div>
        <router-outlet></router-outlet>`,
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    systemMaintance: SystemMaintanceModel = new SystemMaintanceModel();
    isMaintanced = false;

    constructor(
        private appThemeService: AppThemeService
        // private _generalService: GeneralService
    ) {
    }

    ngOnInit() {
        this.appThemeService.initTheme();
    }

    // checkSystemMaintance() {
    //     this._generalService
    //         .checkSystemMaintance()
    //         .subscribe(value => {
    //             this.isMaintanced = true;
    //         }, () => {
    //             this.isMaintanced = false;
    //         })
    // }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts